import React from 'react';
import {
  CompanyIdentificationInformationSection,
  AddressAndContactDetailsSection,
  AdditionalInformationSection,
} from '../../TabsComponent/CompanyInfo/components/CreditReport';
import BusinessIdentityComponent from '../../TabsComponent/CompanyInfo/components/BusinessIdentity';
import CompanyModalAddressesBody from '../../TabsComponent/Summary/ModalAddresses/components/Body';
import CompanyInfoTabTitle from '../../TabsComponent/CompanyInfo/components/TabTitle';
import CompanySeparator from '../../Separator';

const CompanyInfoPrint = ({ companyInfo, otherAddresses, itemsToExport }) => {
  if (!itemsToExport.value) return <></>;

  return (
    <>
      <CompanyInfoTabTitle companyName={companyInfo.companyName} />

      {itemsToExport.items.creditReport.value && (
        <>
          <div className="mrg-top-30 font-size-24 text-bold text-dark">Credit report</div>
          <div className="company-info-credit-report">
            <CompanyIdentificationInformationSection
              creditReportData={companyInfo.creditReport}
            />
            <CompanySeparator margin={0} />

            <AddressAndContactDetailsSection
              creditReportData={companyInfo.creditReport}
            />
            {otherAddresses?.length > 0 &&
              itemsToExport.items.creditReport.items.otherAddresses.value && (
                <CompanyModalAddressesBody addresses={otherAddresses} toPrint />
              )}
            <CompanySeparator margin={0} />

            <AdditionalInformationSection creditReportData={companyInfo.creditReport} />
          </div>
        </>
      )}

      {itemsToExport.items.businessIdentity.value && (
        <>
          <div className="font-size-24 text-bold text-dark mrg-top-30">
            Business identity
          </div>
          <BusinessIdentityComponent
            businessIdentityData={companyInfo.businessIdentity}
            collapseOpened
            hideRiskFactors={
              !itemsToExport.items.businessIdentity.items.riskFactors.value
            }
            hideAttributes={!itemsToExport.items.businessIdentity.items.attributes.value}
          />
        </>
      )}
    </>
  );
};

export default CompanyInfoPrint;
